let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Kt13")).then(() => parcelRequire('8FYIq'));